import React, { useState, useEffect } from 'react';
import { Container, Table, Button,Pagination } from 'react-bootstrap';
import { db } from '../FireBase'; // Ensure correct path and case
import { collection, getDocs ,orderBy,query,where} from 'firebase/firestore';
import { Link } from 'react-router-dom';
import Loading from '../components/Loading';

const Statistics = () => {
    const [schemes, setSchemes] = useState([]);
      const [loading, setLoading] = useState(false);
        const [currentPage, setCurrentPage] = useState(1);
        const itemsPerPage = 20;
    
    useEffect(() => {
        const fetchSchemes = async () => {
            try {
                setLoading(true);
                const schemesQuery = query(collection(db, 'schemes'),where('status', '==', 'Completed'),orderBy('name','asc'));
                const querySnapshot = await getDocs(schemesQuery);
                const schemesList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setSchemes(schemesList);
                
            } catch (error) {
                console.error('Error fetching schemes:', error);
            }finally{
                setLoading(false);
            }
        };

        fetchSchemes();
    }, []);
    const totalPages = Math.ceil(schemes.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = schemes.slice(indexOfFirstItem, indexOfLastItem);


    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    if (loading) {
        // Render loading screen
        
        return (
          <div className="loading-screen">
            
          <Loading/>
          </div>
        );
      }
    return (
        <Container fluid className="p-4">
            <h1>Scheme Statistics</h1>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Scheme Name</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((scheme, index) => (
                        <tr key={scheme.id}>
                            <td>{index + 1}</td>
                            <td>{scheme.name}</td>
                            <td>
                            <Link to={`/statisticesdetailed/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                                <Button className='btn' variant='outline-success' >View Details</Button>
                            </Link>
                               
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
             <Pagination>
                                             {currentPage > 3 && (
                                                 <>
                                                 <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
                                                 <Pagination.Ellipsis disabled />
                                                 </>
                                             )}
                             
                                             {Array.from({ length: 5 }, (_, i) => {
                                                 const page = currentPage - 2 + i;
                                                 if (page > 0 && page <= totalPages) {
                                                 return (
                                                     <Pagination.Item
                                                     key={page}
                                                     active={page === currentPage}
                                                     onClick={() => paginate(page)}
                                                     >
                                                     {page}
                                                     </Pagination.Item>
                                                 );
                                                 }
                                                 return null;
                                             })}
                             
                                             {currentPage < totalPages - 2 && (
                                                 <>
                                                 <Pagination.Ellipsis disabled />
                                                 <Pagination.Item onClick={() => paginate(totalPages)}>{totalPages}</Pagination.Item>
                                                 </>
                                             )}
                                             </Pagination>
        </Container>
    );
};

export default Statistics;